import { Link } from "react-router-dom";
import { Diamond } from "lucide-react";
import { Separator } from "@/components/ui/separator";

const Footer = () => {
  return (
    <footer className="bg-gradient-noir border-t border-border/30 mt-auto">
      <div className="container mx-auto px-4 py-16">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-8">
          {/* Brand Section */}
          <div className="space-y-6">
            <Link to="/" className="flex items-center gap-3 group">
              <div className="p-2.5 bg-gradient-hero rounded-xl shadow-gold transition-all duration-500 group-hover:shadow-glow group-hover:scale-105">
                <Diamond className="h-5 w-5 text-primary-foreground" />
              </div>
              <span className="text-2xl font-display font-semibold luxury-text">
                Art Experto
              </span>
            </Link>
            <p className="text-sm text-secondary-foreground/60 leading-relaxed font-light">
              Your intelligent platform for art discovery, analysis, and collection. 
              Where passion meets precision.
            </p>
            <div className="flex items-center gap-2">
              <div className="w-8 h-px bg-gradient-gold" />
              <span className="text-2xs text-elegant tracking-luxury text-secondary-foreground/40">Est. 2024</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-elegant text-xs tracking-elegant text-secondary-foreground/80 mb-6">Quick Links</h3>
            <ul className="space-y-4">
              {[
                { to: "/gallery", label: "Gallery" },
                { to: "/marketplace", label: "Marketplace" },
                { to: "/art-analysis", label: "Art Analysis" },
                { to: "/art-auction", label: "Art Auction" },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-300 font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h3 className="text-elegant text-xs tracking-elegant text-secondary-foreground/80 mb-6">Resources</h3>
            <ul className="space-y-4">
              {[
                { to: "/art-news", label: "Art News" },
                { to: "/chat", label: "AI Chat" },
                { to: "/premium", label: "Premium" },
                { to: "/forum", label: "Community" },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-300 font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="text-elegant text-xs tracking-elegant text-secondary-foreground/80 mb-6">Company</h3>
            <ul className="space-y-4">
              {[
                { to: "/about", label: "About Art Experto" },
                { to: "/about#faq", label: "FAQ" },
                { to: "/about#terms", label: "Terms & Conditions" },
                { to: "/about#privacy", label: "Privacy Policy" },
              ].map((link) => (
                <li key={link.to}>
                  <Link 
                    to={link.to} 
                    className="text-sm text-secondary-foreground/60 hover:text-primary transition-colors duration-300 font-light"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Decorative divider */}
        <div className="flex items-center gap-4 my-12">
          <div className="flex-1 h-px bg-gradient-to-r from-transparent to-secondary-foreground/10" />
          <Diamond className="h-4 w-4 text-primary/40" />
          <div className="flex-1 h-px bg-gradient-to-l from-transparent to-secondary-foreground/10" />
        </div>

        {/* Bottom Section */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-secondary-foreground/40 font-light">
            © {new Date().getFullYear()} ArtExperto.com | All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <span className="text-2xs text-elegant tracking-elegant text-secondary-foreground/30">
              Crafted with passion
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;